import React, { useRef } from "react";
import { motion, useInView, useAnimation } from "framer-motion";
import HeroSection from "../../components/HeroSection";
import { FaEnvelope, FaPhone, FaMapMarkerAlt, FaUser } from "react-icons/fa";
import classStudents from "../../assets/gallery/education/classstudents.png";
import team from "../../assets/gallery/community-projects/team.jpeg";
import presidentImage from "../../assets/team/president_chiko.png";
import secretaryImage from "../../assets/team/may_anyabolu.png";
import godsonImage from "../../assets/team/godson_emeka.jpg";
import chiefJoeImage from "../../assets/team/Hon_Chief_Joe.jpeg";
import graceImage from "../../assets/team/Grace_Uzochukwu.jpeg";
import doctorAmbroseImage from "../../assets/team/Doctor_ambrose.jpg";
import chiefUcheImage from "../../assets/team/Uche_Amaechi.jpeg";

const AnimatedSection = ({ children, delay = 0, className = "" }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });
  const controls = useAnimation();

  if (isInView) {
    controls.start("visible");
  }

  return (
    <motion.div
      ref={ref}
      initial="hidden"
      animate={controls}
      variants={{
        hidden: { opacity: 0, y: 30 },
        visible: { opacity: 1, y: 0 }
      }}
      transition={{ duration: 0.6, delay }}
      className={className}
    >
      {children}
    </motion.div>
  );
};

export default function OurTeam() {
  const boardMembers = [
    {
      name: "Chief (Mrs) Chiko Ugokwe-Udemba",
      position: "National President",
      // location: "Houston, TX",
      // email: "president@ojotounion.org",
      // phone: "+1 (713) 555-0123",
      image: presidentImage,
      imagePosition: "50% 40%"
    },
    {
      name: "High Chief Dr Ambrose Okonkwo",
      position: "Chairman,Technology Project Committee",
      // location: "Chairman,Technology Project Committee",
      // email: "vicepresident@ojotounion.org",
      // phone: "+1 (416) 555-0124"
      image: doctorAmbroseImage,
      imagePosition: "50% 20%"
    },
    {
      name: "May Anyabolu",
      position: "National Secretary & Member of Tech Committee",
      // location: "Atlanta, GA",
      // email: "secretary@ojotounion.org",
      // phone: "+1 (404) 555-0125",
      image: secretaryImage,
      imagePosition: "50% 22%"
    },
    {
      name: "Dr. Grace  Uzochukwu ( AKA - Ada- Jesus)",
      position: "The Vice President of Ojoto Akanasato  North America and  Ojoto Tech Project Committee Member",
      // location: "Dallas, TX",
      // email: "treasurer@ojotounion.org",
      // phone: "+1 (214) 555-0126"
      image: graceImage,
      imagePosition: "50% 20%"
    },
    {
      name: "Chief Uche Amaechi",
      position: "Ojoto Tech Project Committee Member",
      // location: "Chicago, IL",
      // email: "financial@ojotounion.org",
      // phone: "+1 (312) 555-0127"
      image: chiefUcheImage,
      imagePosition: "50% 20%"
    },
    {
      name: "Hon. Chief joe Oziko Okoye",
      position: "Chairman, Ojoto Akanasato union tri-State and  Ojoto Tech Project Committee Member",
      // location: "New York, NY",
      // email: "pro@ojotounion.org",
      // phone: "+1 (212) 555-0128"
      image: chiefJoeImage,
      imagePosition: "50% 18%"
    },
    {
      name: "Engr Godson Emeka Chikelu",
      position: "Ojoto Tech Project Committee Member",
      // location: "Dallas, TX",
      // email: "member@ojotounion.org",
      // phone: "+1 (000) 000-0000",
      image: godsonImage,
      imagePosition: "50% 20%"
    }
  ];

  return (
    <div className="w-full bg-white">
      <HeroSection
        title="Our Team"
        subtitle="Meet the dedicated leaders and volunteers who drive our mission forward and serve our community with passion and commitment."
        buttons={[
          { text: "Apply Now", link: "/register", variant: "blue" },
          { text: "Login", link: "/login", variant: "blue" }
        ]}
        heroImage={team}
      />

      {/* Board Members Section */}
      <section className="section bg-white">
        <div className="section-container">
          <AnimatedSection>
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
                Board Members
              </h2>
              <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                Our board members bring diverse expertise and unwavering commitment to advancing our mission.
              </p>
            </div>
          </AnimatedSection>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {boardMembers.map((member, index) => (
              <AnimatedSection key={index} delay={0.2 + index * 0.1}>
                <div className="card overflow-hidden !p-0">
                  <div className="h-64 overflow-hidden bg-gray-100 flex items-center justify-center">
                    {member.image ? (
                      <img
                        src={member.image}
                        alt={member.name}
                        className="w-full h-full object-cover"
                        style={{ objectPosition: member.imagePosition || "50% 20%" }}
                      />
                    ) : (
                      <div className="w-full h-full flex items-center justify-center bg-primary-50 text-primary-300 text-5xl">
                        <FaUser />
                      </div>
                    )}
                  </div>
                  <div className="p-6">
                    <h3 className="text-xl font-bold text-gray-800 mb-1">
                      {member.name}
                    </h3>
                    <p className="text-primary-600 font-semibold mb-4 text-sm">
                      {member.position}
                    </p>
                    <div className="space-y-2 text-sm text-gray-600">
                      <div className="flex items-center gap-2">
                        {/* <FaMapMarkerAlt className="text-primary-600" /> */}
                        <span>{member.location}</span>
                      </div>
                      <div className="flex items-center gap-2">
                        {/* <FaEnvelope className="text-primary-600" /> */}
                        <a href={`mailto:${member.email}`} className="hover:text-primary-600">
                          {member.email}
                        </a>
                      </div>
                      <div className="flex items-center gap-2">
                        {/* <FaPhone className="text-primary-600" /> */}
                        <span>{member.phone}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </AnimatedSection>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
